import React from "react";
import { useNavigate } from "react-router";

import {
  PlusIcon,
} from "@heroicons/react/24/outline";

// 05 Feb 2026
import {
  EyeIcon,
  EyeSlashIcon,
} from "@heroicons/react/24/solid";


import EtWabReflectionIcon1SVGComp from "@/assets/img/icons/svgComp/EtWabReflectionIcon1SVGComp";
import EtReflectionCardMobile from "@/components/reflections/EtReflectionCardMobile";

import { useGetUserReflectionsAllQuery } from "@/features/userReflections/userReflectionsApiSlice";
import { useGetOrganizationsQuery } from "@/features/organizations/organizationsApiSlice"; // 30 Jan 2026
import { useGetUsersQuery } from "@/features/users/usersApiSlice"; // 30 Jan 2026


import EtModalUpdateUserReflection from "@/components/common/modal/EtModalUpdateUserReflection";
import EtModalCreateUserReflection from "@/components/common/modal/EtModalCreateUserReflection";
import EtModalDeleteUserReflection from "@/components/common/modal/EtModalDeleteUserReflection";

// 09 Dec 2025
import {
  ComposedChart,
  LineChart,
  Line,
  Bar, // 12 Dec 2025
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Scatter,
  Cell,
  Legend,
} from "recharts";

import moment from "moment";

// 26 Jan 2026
import { CircularProgressbarWithChildren } from 'react-circular-progressbar'

import User from "@/components/common/user/User"

import { userProfileIcon2 } from "@/assets/img/imgAssets"

// 29 Jan 2026
import useAuth from "@/hooks/useAuth";

// 24 Feb 2026
import EtLogoutIcon1SVGComp from "@/assets/img/icons/svgComp/EtLogoutIcon1SVGComp" 
import TrinityIcon from '@/assets/img/icons/base64Svgs/trinityRoundIcon1.svg'
import { useSendLogoutMutation } from "@/features/auth/authApiSlice"

const EtTrinityReflectionCenterMobile = ({
  // userId = "",
  // userOrgId = "",
  // onClose,
}) => {
 
// First Created - 24 Feb 2026
// Author - Atul Pandey
// Inherited from EtTrinityReflectionCenter.jsx comp and refined the display JSX for mobile.

// Original Comp Update Trail
// -----------------------------------------
// First Created - 02 Dec 2025
// Author - Atul Pandey
// Purpose - Let user manage all their reflections from one place
// Updated - 03 Dec 2025 - Data + time filtering chips + display
// Updated - 04 Dec 2025 - Wired update modal
// Updated - 05 Dec 2025 - Wired create + delete modal
// Updated - 05 Dec 2025 - Added search + highlighting
// Updated - 05 Dec 2025 - PERFORMANCE FIXES (Option 1): Debounced search, preprocessed reflections, token-based fuzzy search in filtering only, simple highlight for rendering.
// Updated - 09 Dec 2025 - Reflection Habit Charts
// Updated - 12 Dec 2025 - Added Bar and refined charts to show daily & cumulative reflections - similar to Reflections
// Updated - 02 Jan 2026 - added time chips for "All" and "By Year"
// Updated - 02 Jan 2026 - refined the end of quarter moment definition
// Updated - 24 Jan 2026 - refined for org sponsor level data show (Self | Collective)
// Updated - 26 Jan 2026 - refined for contribution view in the collective
// Updated - 26 Jan 2026 - refined for purpose native universe view
// Updated - 29 Jan 2026 - refined for EtAdmins to dig deeper by org in purpose native universe view
// Updated - 30 Jan 2026 - continued refinements for EtAdmins to dig deeper by org in purpose native universe view
// Updated - 30 Jan 2026 - get org data for org matching for etadmin view
// Updated - 31 Jan 2026 - charts for byOrg
// Updated - 05 Feb 2026 - org name masking in byOrg
// Updated - 06 Feb 2026 - refined collective and collective and universe view access
// Updated - 06 Feb 2026 - added showOwner prop to EtReflectionCard

// 0 - 29 Jan 2026 - Determine user Auth state
const { 
  isEtAdmin, 
  isEtCoach, 
  isSponsor,    // 06 Feb 2026
  isOrgAdmin,   // 06 Feb 2026 
  username,     // 24 Feb 2026
} = useAuth();

const canViewAdminUniverse = isEtAdmin || isEtCoach;

const navigate = useNavigate(); // 24 Feb 2026

// 06 Feb 2026
const canViewCollective = isSponsor || isOrgAdmin;

// -----------------------------------------
// 1. Local State
// -----------------------------------------
const [activeTimeBucket, setActiveTimeBucket] = React.useState("today");

// ⭐ 02 Jan 2026 - NEW — active year for "By Year"
const [activeYear, setActiveYear] = React.useState(moment().year());

const [searchText, setSearchText] = React.useState("");       // UI value
const [debouncedSearch, setDebouncedSearch] = React.useState("");  // effective value

const [showDetail, setShowDetail] = React.useState({});

// 04 Dec 2025 - Update modal
const [showUpdateModal, setShowUpdateModal] = React.useState(false);
const [selectedAtomicRecord, setSelectedAtomicRecord] = React.useState(null);

// 05 Dec 2025 - Create / Delete
const [showCreateModal, setShowCreateModal] = React.useState(false);
const [showDeleteModal, setShowDeleteModal] = React.useState(false);
const [selectedDeleteRecord, setSelectedDeleteRecord] = React.useState(null);

// 09 Dec 2025 - Habit charting
const [activeViewTab, setActiveViewTab] = React.useState("log"); 

// 12 Dec 2025 - ⭐ NEW — chart sub-tab (streak | counts)
const [chartTab, setChartTab] = React.useState("streak");

// ⭐ 24 Jan 2026 - Collective View (same pattern as Conversations)
const [viewMode, setViewMode] = React.useState("self"); // "self" | "collective" | "universe"
const [activeCollectiveUserId, setActiveCollectiveUserId] = React.useState("all");  

const [chartViewMode, setChartViewMode] = React.useState("aggregate"); // "aggregate" | "compare"

// ⭐ 29 Jan 2026 — Universe Sub Tabs (Admin only)
const [universeTab, setUniverseTab] = React.useState("myOrg"); // myOrg | byOrg

// ⭐ 31 Jan 2026 – selected user per org for chart focus
const [selectedOrgUserMap, setSelectedOrgUserMap] = React.useState({});

// 🔒 05 Feb 2026 – org name visibility (masked by default)
const [showOrgNameMap, setShowOrgNameMap] = React.useState({});

// 🔒 05 Feb 2026 – user name visibility (masked by default)
const [showUserNameMap, setShowUserNameMap] = React.useState({});



  // -----------------------------------------
  // 2a. Load Reflection Data (Atomic Records)
  // -----------------------------------------

  // 26 Jan 2026 - Purpose Native Universe View
  const {
  data: reflectionsResponse,
  isLoading,
  refetch: refetchUserReflectionsAll,
  } = useGetUserReflectionsAllQuery();

  // console.log('reflectionsResponse', reflectionsResponse)

  // 24 Feb 2026 - HandleLogout Mutation
  const [sendLogout, {}] = useSendLogoutMutation() 


  // ⭐ 26 Jan 2026 — All Reflections Raw
  const allReflectionsRaw = React.useMemo(() => {
    if (!reflectionsResponse) return [];
    if (Array.isArray(reflectionsResponse)) return reflectionsResponse;
    return reflectionsResponse.reflections || [];
  }, [reflectionsResponse]);

  // ⭐ 26 Jan 2026 — Org Daily Totals Raw
  const orgDailyTotalsRaw = React.useMemo(() => {
    if (!reflectionsResponse) return [];
    if (Array.isArray(reflectionsResponse)) return [];
    return reflectionsResponse.orgDailyTotals || [];
  }, [reflectionsResponse]);

  // ⭐ 26 Jan 2026 — Normalize Org Daily Totals by Date (Universe Baseline)
  const orgDailyTotalsByDate = React.useMemo(() => {
    if (!orgDailyTotalsRaw || orgDailyTotalsRaw.length === 0) return {};

    return orgDailyTotalsRaw.reduce((acc, item) => {
      // Defensive guards (backend already mostly clean, but be safe)
      if (!item?.date) return acc;
      if (typeof item.dailyCount !== "number") return acc;

      acc[item.date] = item.dailyCount;
      return acc;
    }, {});
  }, [orgDailyTotalsRaw]);

  // console.log("Org Daily Totals (Universe):", orgDailyTotalsByDate);

  // 30 Jan 2026 - Extract Organizations 
  const { data: organizationsData = [] } = useGetOrganizationsQuery();
  const { data: usersResponse } = useGetUsersQuery();
  // const { data: usersResponse } = useGetUsersQuery(undefined, {
  //   skip: !canViewAdminUniverse,
  // });

  const extractEntitiesFromAdapter = (dataAdapter) => {
    if (!dataAdapter || !dataAdapter.ids || !dataAdapter.entities) return [];
    return dataAdapter.ids.map((id) => dataAdapter.entities[id]);
  };

  const organizations = extractEntitiesFromAdapter(organizationsData);
  const allUsers = extractEntitiesFromAdapter(usersResponse);

  // 24 Feb 2026 -  User Info
  const extractFilteredEntitiesFromAdapter = (dataAdapter) => {
    if (!dataAdapter || !dataAdapter.ids || !dataAdapter.entities) return [];
    return dataAdapter.ids.map((id) => dataAdapter.entities[id])
    ?.filter(
        (item) => item?.username === username
        );
  };

  const userInfo = extractFilteredEntitiesFromAdapter(usersResponse)

   const userId = userInfo[0]?._id || null
   const userOrgId = userInfo[0]?.userOrgId?._id || null

  // console.log('users', allUsers)

  // 30 Jan 2026 - Build OrgId to organizationName map to be used in byOrg tab in Universe view
  const orgIdToNameMap = React.useMemo(() => {
    const map = {};
    organizations.forEach(org => {
      map[org._id?.toString()] = org.organizationName || "Unknown Org";
    });
    return map;
  }, [organizations]);

  // console.log('orgIdToNameMap', orgIdToNameMap)



  // Prior Code - Commented - Kept for reference - DO NOT DELETE  

  // const {
  //   data: allReflectionsRaw = [],
  //   isLoading,
  //   refetch: refetchUserReflectionsAll,
  // } = useGetUserReflectionsAllQuery();



  // -----------------------------------------
  // 3. Preprocess Reflections (strip HTML once)
  // -----------------------------------------
  const preprocessHtml = (html = "") =>
    html.replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim().toLowerCase();

  const allReflections = React.useMemo(() => {
    return allReflectionsRaw.map((ref) => ({
      ...ref,
      __plainText: preprocessHtml(ref.reflectionNoteText),
    }));
  }, [allReflectionsRaw]);

  // ⭐ 24 Jan 2026 -  Unique users for Collective view
  const collectiveUsers = React.useMemo(() => {
    // if (viewMode !== "collective") return [];

    const map = new Map();

    allReflections.forEach(ref => {
      if (ref.userId?._id && !map.has(ref.userId._id)) {
        map.set(ref.userId._id, {
          _id: ref.userId._id,
          name: ref.userId.name || ref.userId.username || "User",
        });
      }
    });

    return Array.from(map.values());
  }, [
    allReflections, 
    // viewMode
  ]);

  // console.log('collective users : ', collectiveUsers)

  // 24 Jan 2026 - Reset the users based on the viewMode
  React.useEffect(() => {
    if (viewMode === "collective") {
      setActiveCollectiveUserId("all");
    }
  }, [viewMode]);

  // 29 Jan 2026 - Universe Subtab reset
  React.useEffect(() => {
    if (viewMode !== "universe") return;
    setUniverseTab("myOrg");
  }, [viewMode]);

  // ⭐ 25 Jan 2026 - Fix: prevent stale "compare" mode when collective user != Everyone
  React.useEffect(() => {
    if (viewMode !== "collective") {
      setChartViewMode("aggregate");
      return;
    }

    if (activeCollectiveUserId !== "all") {
      setChartViewMode("aggregate");
    }
  }, [viewMode, activeCollectiveUserId]);
  

  // 🔒 24 Jan 2026 - Backend already scopes data based on role
  const baseViewReflections = React.useMemo(() => {
    return allReflections;
  }, [allReflections]);

  // 24 Jan 2026 - Build user scoped reflections - Self | Collective (Everyone)
  const userScopedReflections = React.useMemo(() => {
    // SELF → logged-in user only
    if (viewMode === "self") {
      return baseViewReflections.filter(
        r => r.userId?._id === userId
      );
    }

    // COLLECTIVE → Everyone
    if (activeCollectiveUserId === "all") {
      return baseViewReflections;
    }

    // COLLECTIVE → Specific user
    return baseViewReflections.filter(
      r => r.userId?._id === activeCollectiveUserId
    );
  }, [
    baseViewReflections,
    viewMode,
    activeCollectiveUserId,
    userId,
  ]);

  // -----------------------------------------
  // 4. Debounce Search (critical for performance)
  // -----------------------------------------
  React.useEffect(() => {
    const handle = setTimeout(() => {
      setDebouncedSearch(searchText);
    }, 300);

    return () => clearTimeout(handle);
  }, [searchText]);


  // -----------------------------------------
  // 5. Time Boundaries
  // -----------------------------------------
  const now = moment();
  const startOfToday = moment().startOf("day");
  const endOfToday = moment().endOf("day");

  const startOfWeek = moment().isoWeekday(1).startOf("day");
  const endOfWeek = endOfToday;

  const actualEndOfWeek = moment().isoWeekday(7).endOf("day"); // 02 Jan 2026 Sunday of current week

  const startOfMonth = moment().startOf("month");
  const endOfMonth = moment().isSame(now, "month") ? endOfToday : moment().endOf("month");

  const startOfQuarter = moment().startOf("quarter");
  const endOfQuarter = moment().isSame(now, "quarter") ? endOfToday : moment().endOf("quarter");

  const startOfYear = moment().startOf("year");
  const endOfYear = moment().isSame(now, "year") ? endOfToday : moment().endOf("year");


  // -----------------------------------------
  // 6. Time-Based Filtering
  // -----------------------------------------
  const filterByTime = (refs, start, end) =>
    refs.filter((ref) => {
      const d = moment(ref.reflectionDate);
      return d.isBetween(start, end, null, "[]");
    });

  // 24 Jan 2026 - Refined to allow viewing user specific conversations as well
  const reflectionsToday = filterByTime(userScopedReflections, startOfToday, endOfToday);
  const reflectionsThisWeek = filterByTime(userScopedReflections, startOfWeek, endOfWeek);
  const reflectionsThisMonth = filterByTime(userScopedReflections, startOfMonth, endOfMonth);
  const reflectionsThisQuarter = filterByTime(userScopedReflections, startOfQuarter, endOfQuarter);
  const reflectionsThisYear = filterByTime(userScopedReflections, startOfYear, endOfYear);
  
  // console.log('reflectionsToday', reflectionsToday)

  // 24 Jan 2026 - Commented out to allow viewing user specific conversations as well
  // const reflectionsToday = filterByTime(allReflections, startOfToday, endOfToday);
  // const reflectionsThisWeek = filterByTime(allReflections, startOfWeek, endOfWeek);
  // const reflectionsThisMonth = filterByTime(allReflections, startOfMonth, endOfMonth);
  // const reflectionsThisQuarter = filterByTime(allReflections, startOfQuarter, endOfQuarter);
  // const reflectionsThisYear = filterByTime(allReflections, startOfYear, endOfYear);

  // ⭐ 02 Jan 2026 - NEW — derive available years for By Year selector
  const availableYears = React.useMemo(() => {
    const years = new Set();

    allReflections.forEach(ref => {
      const y = moment(ref.reflectionDate).year();
      years.add(y);
    });

    const sorted = Array.from(years).sort((a, b) => b - a);

    // Always include current year (even if no reflections yet)
    const currentYear = moment().year();
    if (!sorted.includes(currentYear)) {
      sorted.unshift(currentYear);
    }

    return sorted;
  }, [
    allReflections     
  ]);

  
  // -----------------------------------------
  // 7. Determine displayed set
  // -----------------------------------------
  let displayedReflections = [];

  switch (activeTimeBucket) {
    case "week":
      displayedReflections = reflectionsThisWeek;
      break;
    case "month":
      displayedReflections = reflectionsThisMonth;
      break;
    case "quarter":
      displayedReflections = reflectionsThisQuarter;
      break;
    case "year":
      displayedReflections = reflectionsThisYear;
      break;

    // 02 Jan 2026
    case "byYear": {
      const start = moment().year(activeYear).startOf("year");
      const end = moment().year(activeYear).isSame(moment(), "year")
        ? endOfToday
        : moment().year(activeYear).endOf("year");

      // displayedReflections = filterByTime(allReflections, start, end);     // 24 Jan 2026 - commented out
      displayedReflections = filterByTime(userScopedReflections, start, end); // 24 Jan 2026 - added
      break;
    }

    case "all":
      // displayedReflections = allReflections;     // 24 Jan 2026 - commented out
      displayedReflections = userScopedReflections; // 24 Jan 2026 - added
      break;
    case "today":
    default:
      displayedReflections = reflectionsToday;
      break;
  }


  // -----------------------------------------
  // 8. Fuzzy Search - Token Based (Option 1)
  // -----------------------------------------
  const tokenizeSearch = (text) =>
    text.toLowerCase().trim().split(/\s+/).filter(Boolean);

  function levenshteinDistance(a, b) {
    if (!a || !b) return 999;
    const dp = Array(a.length + 1)
      .fill(null)
      .map(() => Array(b.length + 1).fill(null));

    for (let i = 0; i <= a.length; i++) dp[i][0] = i;
    for (let j = 0; j <= b.length; j++) dp[0][j] = j;

    for (let i = 1; i <= a.length; i++) {
      for (let j = 1; j <= b.length; j++) {
        const cost = a[i - 1] === b[j - 1] ? 0 : 1;
        dp[i][j] = Math.min(
          dp[i - 1][j] + 1,
          dp[i][j - 1] + 1,
          dp[i - 1][j - 1] + cost
        );
      }
    }

    return dp[a.length][b.length];
  }

  function matchesReflection(plainText, search) {
    if (!search.trim()) return true;

    const searchTokens = tokenizeSearch(search);
    const tokens = tokenizeSearch(plainText);

    return searchTokens.some((searchToken) =>
      tokens.some((word) => {
        if (word === searchToken) return true;
        if (word.startsWith(searchToken)) return true;
        if (word.includes(searchToken)) return true;

        if (Math.abs(word.length - searchToken.length) <= 2) {
          if (levenshteinDistance(word, searchToken) <= 1) return true;
        }

        return false;
      })
    );
  }


  // -----------------------------------------
  // 9. FINAL FILTERED REFLECTIONS
  // -----------------------------------------
  const finalReflections = React.useMemo(() => {
    if (!displayedReflections) return [];
    if (debouncedSearch.trim() === "") return displayedReflections;

    return displayedReflections.filter((ref) =>
      matchesReflection(ref.__plainText || "", debouncedSearch)
    );
  }, [displayedReflections, debouncedSearch]);


  // -----------------------------------------
  // 10. Highlight (simple, safe)
  // -----------------------------------------
  const createMarkup = (html) => {
    if (!debouncedSearch.trim()) return { __html: html };

    const words = debouncedSearch.toLowerCase().split(/\s+/).filter(Boolean);
    let highlighted = html;

    words.forEach((w) => {
      if (!w) return;
      const regex = new RegExp(`(${w})`, "gi");
      highlighted = highlighted.replace(
        regex,
        `<mark style="background-color:#f59e0b; color:black; padding:0 2px;">$1</mark>`
      );
    });

    return { __html: highlighted };
  };


  // -----------------------------------------
  // 11. Handlers
  // -----------------------------------------
  const toggleShowDetail = (id) =>
    setShowDetail((prev) => ({ ...prev, [id]: !prev[id] }));

  const onEdit = (refItem) => {
    setSelectedAtomicRecord(refItem);
    setShowUpdateModal(true);
  };

  const onDelete = (refItem) => {
    if (refItem.userMagicMomentId) {
      alert("This reflection is a Magic Moment and cannot be deleted.");
      return;
    }
    setSelectedDeleteRecord(refItem);
    setShowDeleteModal(true);
  };

  // -----------------------------------------
  // 12. Chart Section - 09 Dec 2025
  // -----------------------------------------

  // 12.1 - Charts Data
  const { chartData, bucketDates } = React.useMemo(() => {
    const refs = finalReflections;
    if (!refs || refs.length === 0) return { chartData: [], bucketDates: [] };

    let start, end;

    switch (activeTimeBucket) {
      case "week": start = startOfWeek; end = endOfWeek; break;
      case "month": start = startOfMonth; end = endOfMonth; break;
      case "quarter": start = startOfQuarter; end = endOfQuarter; break;
      // 02 Jan 2025
      case "year":
      case "byYear": {
        const targetYear =
          activeTimeBucket === "byYear" ? activeYear : moment().year();

        const yearItems = refs.filter((r) =>
          moment(r.reflectionDate).year() === targetYear
        );

        if (yearItems.length > 0) {
          const sorted = [...yearItems].sort((a, b) =>
            moment(a.reflectionDate).diff(moment(b.reflectionDate))
          );

          start = moment(sorted[0].reflectionDate).startOf("day");
          end = moment(sorted[sorted.length - 1].reflectionDate).endOf("day");
        } else {
          start = moment().year(targetYear).startOf("year");
          end = moment().year(targetYear).endOf("year");
        }

        break;
      }

      // case "year": start = startOfYear; end = endOfYear; break; // 12 Dec 2025
      // case "year": {
      // // 12 Dec 2025 - Filter reflections from THIS calendar year only
      //   const yearItems = refs.filter((r) =>
      //     moment(r.reflectionDate).isSame(moment(), "year")
      //   );

      //   if (yearItems.length > 0) {
      //     // Sort by reflectionDate
      //     const sorted = [...yearItems].sort((a, b) =>
      //       moment(a.reflectionDate).diff(moment(b.reflectionDate))
      //     );

      //     start = moment(sorted[0].reflectionDate).startOf("day");
      //     end = moment(sorted[sorted.length - 1].reflectionDate).endOf("day");
      //   } else {
      //     // Fallback → use entire year if no reflections yet
      //     start = startOfYear;
      //     end = endOfYear;
      //   }
      //   break;
      // }

      case "all": {
        // Sort reflections chronologically
        const sorted = [...refs].sort((a, b) =>
          moment(a.reflectionDate).diff(moment(b.reflectionDate))
        );

        start = moment(sorted[0]?.reflectionDate).startOf("day");
        end = moment(sorted[sorted.length - 1]?.reflectionDate).endOf("day");
        break;
      }
      case "today":
      default: start = startOfToday; end = endOfToday; break;
    }

    // Build list of day keys
    const bucketDates = [];
    let cursor = start.clone();
    while (cursor.isSameOrBefore(end, "day")) {
      bucketDates.push(cursor.format("YYYY-MM-DD"));
      cursor.add(1, "day");
    }

    const dateToIndexMap = {};
    bucketDates.forEach((d, i) => (dateToIndexMap[d] = i));

    // Build chartData
    const chartData = refs.map((ref) => {
      const d = moment(ref.reflectionDate);
      const dateKey = d.format("YYYY-MM-DD");
      const xValue = dateToIndexMap[dateKey] ?? 0;

      const epochMinutes = d.hours() * 60 + d.minutes();

      return {
        reflectionId: ref._id,
        dateKey,
        xValue,
        xLabel: moment(dateKey).format("DD MMM"),
        epochMinutes,
        createdAt: ref.reflectionDate,
      };
    });

    chartData.sort((a, b) => a.xValue - b.xValue);

    return { chartData, bucketDates };
  }, [finalReflections, activeTimeBucket]);

  // 12.2 - For xAxis Labels 
  const allDatePoints = bucketDates.map((d, index) => ({
    xValue: index,
    xLabel: moment(d).format("DD MMM"),
  }));

  // 12.3 - 12 Dec 2025 - ⭐ NEW — Daily Count + Cumulative Count for Reflections
  const dailyCountData = React.useMemo(() => {
    if (!bucketDates || bucketDates.length === 0) return [];

    const dateCountMap = {};
    bucketDates.forEach((d) => (dateCountMap[d] = 0));

    // Count reflections per day
    finalReflections.forEach((ref) => {
      const dateKey = moment(ref.reflectionDate).format("YYYY-MM-DD");
      if (dateCountMap[dateKey] !== undefined) {
        dateCountMap[dateKey] += 1;
      }
    });

    let cumulative = 0;

    return bucketDates.map((d, index) => {
      const count = dateCountMap[d];
      cumulative += count;

      return {
        xValue: index,
        dateKey: d, // ⭐ 02 Jan 2026 - NEW — YYYY-MM-DD
        xLabel: moment(d).format("DD MMM"),
        dailyCount: count,
        cumulativeCount: cumulative,
      };
    });
  }, [bucketDates, finalReflections]);

  // -----------------------------------------
  // 13. Time Scope Description (Reflections) - 02 Jan 2026
  // -----------------------------------------
  const timeBucketDescription = React.useMemo(() => {
    switch (activeTimeBucket) {
      case "today":
        return (
          <>
            Today is{" "}
            <span className="font-semibold">
              {now.format("DD MMM YYYY")}
            </span>
          </>
        );

      case "week":
        return (
          <>
            This week — Mon (
            <span className="font-semibold">
              {startOfWeek.format("DD MMM YYYY")}
            </span>
            ) – Sun (
            <span className="font-semibold">
              {actualEndOfWeek.format("DD MMM YYYY")}
            </span>
            )
          </>
        );

      case "month":
        return (
          <>
            This month is{" "}
            <span className="font-semibold">
              {startOfMonth.format("MMMM YYYY")}
            </span>
          </>
        );

      case "quarter": {
        const quarter = now.quarter();
        return (
          <>
            This quarter is{" "}
            <span className="font-semibold text-orange-600">
              Q{quarter} of {now.year()}
            </span>
            . Starting:{" "}
            <span className="font-semibold">
              {startOfQuarter.format("DD MMM YYYY")}
            </span>
            , Ending:{" "}
            <span className="font-semibold">
              {moment().endOf("quarter").format("DD MMM YYYY")}
            </span>
          </>
        );
      }

      case "year":
        return (
          <>
            This year is{" "}
            <span className="font-semibold">
              {now.year()}
            </span>
          </>
        );

      case "byYear":
        return (
          <>
            Showing data for year{" "}
            <span className="font-semibold">
              {activeYear}
            </span>
          </>
        );

      case "all":
        return (
          <>
            <span className="font-semibold">All</span> the logged reflections
          </>
        );

      default:
        return null;
    }
  }, [
    activeTimeBucket,
    activeYear,
    now,
    startOfWeek,
    endOfWeek,
    startOfMonth,
    startOfQuarter,
  ]);

  // -----------------------------------------
  // 14. Helper for screening if user can see others' reflections - 24 Jan 2026
  // -----------------------------------------
  const canViewFullReflection = (reflection, loggedInUserId) => {
    // Always allow own reflections
    if (reflection.userId?._id === loggedInUserId) return true;

    // Allow if explicitly shared
    if (Array.isArray(reflection.sharedWith)) {
      return reflection.sharedWith.some(
        sw => sw.userId === loggedInUserId || sw.userId?._id === loggedInUserId
      );
    }

    return false;
  };

  // -----------------------------------------
  // 15. Group reflections by user (Phase 3) - 24 Jan 2026
  // -----------------------------------------
  const reflectionsByUser = React.useMemo(() => {
    const map = new Map();

    finalReflections.forEach(ref => {
      const uid = ref.userId?._id;
      if (!uid) return;

      if (!map.has(uid)) {
        map.set(uid, {
          userId: uid,
          userName: ref.userId?.name || ref.userId?.username || "User",
          reflections: [],
        });
      }

      map.get(uid).reflections.push(ref);
    });

    return Array.from(map.values());
  }, [finalReflections]);

  // -----------------------------------------
  // 15b - Per User Daily + Cumulative (Compare) - 24 Jan 2026
  // -----------------------------------------
  const perUserDailyCumulativeData = React.useMemo(() => {
    if (!bucketDates || bucketDates.length === 0) return [];

    return reflectionsByUser.map(user => {
      const dateCountMap = {};
      bucketDates.forEach(d => (dateCountMap[d] = 0));

      user.reflections.forEach(ref => {
        const d = moment(ref.reflectionDate).format("YYYY-MM-DD");
        if (dateCountMap[d] !== undefined) {
          dateCountMap[d]++;
        }
      });

      let cumulative = 0;

      const series = bucketDates.map((d, idx) => {
        cumulative += dateCountMap[d];

        return {
          xValue: idx,
          dateKey: d,
          xLabel: moment(d).format("DD MMM"),
          dailyCount: dateCountMap[d],
          cumulativeCount: cumulative,
        };
      });

      return {
        userId: user.userId,
        userName: user.userName,
        series,
      };
    });
  }, [reflectionsByUser, bucketDates]);

  // ⭐ 26 Jan 2026 - Time-scoped reflections (used by charts + contributions)
  const timeScopedReflections = React.useMemo(() => {
      switch (activeTimeBucket) {
        case "week":
          return reflectionsThisWeek;
        case "month":
          return reflectionsThisMonth;
        case "quarter":
          return reflectionsThisQuarter;
        case "year":
          return reflectionsThisYear;
        case "byYear":
          return userScopedReflections.filter(c =>
            moment(c.createdAt).year() === activeYear
          );
        case "all":
          return userScopedReflections;
        case "today":
        default:
          return reflectionsToday;
      }
    }, [
      activeTimeBucket,
      reflectionsToday,
      reflectionsThisWeek,
      reflectionsThisMonth,
      reflectionsThisQuarter,
      reflectionsThisYear,
      userScopedReflections,
      activeYear,
   ]);
  
  // ⭐ 26 Jan 2026 - Group time-scoped reflections by user
  const timeScopedReflectionsByUser = React.useMemo(() => {
    const map = new Map();
  
    timeScopedReflections.forEach(c => {
      const uid = c.userId?._id;
      if (!uid) return;
  
      if (!map.has(uid)) {
        map.set(uid, {
          userId: uid,
          userName: c.userId?.name ||  "User",
          username: c.userId?.username || "",
          reflections: [],
        });
      }
  
      map.get(uid).reflections.push(c);
    });
  
    return Array.from(map.values());
  }, [timeScopedReflections]);

  // -----------------------------------------
  // ⭐ 26 Jan 2026 - Collective Reflection Contribution Snapshot
  // -----------------------------------------
  
  const reflectionContributionSnapshot = React.useMemo(() => {
    if (!timeScopedReflectionsByUser.length) return null;
  
    const total = timeScopedReflectionsByUser.reduce(
      (sum, u) => sum + u.reflections.length,
      0
    );
  
    if (total === 0) return null;
  
    return {
      total,
      contributors: timeScopedReflectionsByUser.map(u => ({
        userId: u.userId,
        userName: u.userName,
        username: u.username,
        count: u.reflections.length,
        percentOfTotal: Math.round((u.reflections.length / total) * 100),
      }))
      .sort((a, b) => b.percentOfTotal - a.percentOfTotal),
    };
  }, [timeScopedReflectionsByUser]);
  
  // 26 Jan 2026 - Handle Collective User Select - Switch from Everyone to other users for "Contributions" Tab
  const handleCollectiveUserSelect = (userId) => {
    setActiveCollectiveUserId(userId);
  
    if (userId !== "all" && activeViewTab === "contributions") {
      setActiveViewTab("log");
    }
  };

  // ⭐ 26 Jan 2026 - For filterig for Universe views
  const isUniverseView = viewMode === "universe";

  // ⭐ 26 Jan 2026 — Universe: normalize org daily totals by date
  const universeDateCountMap = React.useMemo(() => {
    const map = {};

    orgDailyTotalsRaw.forEach(row => {
      if (!row?.date || typeof row.dailyCount !== "number") return;

      // date already comes as YYYY-MM-DD from backend
      map[row.date] = (map[row.date] || 0) + row.dailyCount;
    });

    return map;
  }, [orgDailyTotalsRaw]);

  // ⭐ 26 Jan 2026 — Universe bucket dates (time scoped)
  const universeBucketDates = React.useMemo(() => {
    if (!isUniverseView) return [];

    let start, end;

    switch (activeTimeBucket) {
      case "week":
        start = startOfWeek;
        end = endOfWeek;
        break;
      case "month":
        start = startOfMonth;
        end = endOfMonth;
        break;
      case "quarter":
        start = startOfQuarter;
        end = endOfQuarter;
        break;
      case "year":
        start = startOfYear;
        end = endOfYear;
        break;
      case "byYear": {
        start = moment().year(activeYear).startOf("year");
        end = moment().year(activeYear).isSame(moment(), "year")
          ? endOfToday
          : moment().year(activeYear).endOf("year");
        break;
      }
      case "all": {
        const dates = Object.keys(universeDateCountMap);
        if (!dates.length) return [];

        const sorted = dates.sort();
        start = moment(sorted[0]);
        end = moment(sorted[sorted.length - 1]);
        break;
      }
      case "today":
      default:
        start = startOfToday;
        end = endOfToday;
        break;
    }

    const buckets = [];
    let cursor = start.clone();

    while (cursor.isSameOrBefore(end, "day")) {
      buckets.push(cursor.format("YYYY-MM-DD"));
      cursor.add(1, "day");
    }

    return buckets;
  }, [
    isUniverseView,
    activeTimeBucket,
    universeDateCountMap,
    startOfToday,
    endOfToday,
    startOfWeek,
    endOfWeek,
    startOfMonth,
    endOfMonth,
    startOfQuarter,
    endOfQuarter,
    startOfYear,
    endOfYear,
  ]);

  // ⭐ 26 Jan 2026 — Universe totals for active time bucket
  const universeTimeScopedTotals = React.useMemo(() => {
    if (!orgDailyTotalsRaw.length) return [];

    return orgDailyTotalsRaw.filter(d => {
      if (!d.date) return false;
      const m = moment(d.date);

      switch (activeTimeBucket) {
        case "today":
          return m.isSame(startOfToday, "day");

        case "week":
          return m.isBetween(startOfWeek, endOfWeek, null, "[]");

        case "month":
          return m.isBetween(startOfMonth, endOfMonth, null, "[]");

        case "quarter":
          return m.isBetween(startOfQuarter, endOfQuarter, null, "[]");

        case "year":
          return m.isBetween(startOfYear, endOfYear, null, "[]");

        case "byYear":
          return m.year() === activeYear;

        case "all":
        default:
          return true;
      }
    });
  }, [
    orgDailyTotalsRaw,
    activeTimeBucket,
    activeYear,
    startOfToday,
    startOfWeek,
    endOfWeek,
    startOfMonth,
    endOfMonth,
    startOfQuarter,
    endOfQuarter,
    startOfYear,
    endOfYear,
  ]);

  // ⭐ 26 Jan 2026 - Universe aggregate count (no users involved)
  const universeTotalCount = React.useMemo(() => {
    return universeTimeScopedTotals.reduce(
      (sum, d) => sum + (d.dailyCount || 0),
      0
    );
  }, [universeTimeScopedTotals]);

  // ⭐ 26 Jan 2026 — Universe daily + cumulative series (chart-ready)
  const universeDailyCumulativeData = React.useMemo(() => {
    if (!isUniverseView || !universeBucketDates.length) return [];

    let cumulative = 0;

    return universeBucketDates.map((dateKey, index) => {
      const dailyCount = universeDateCountMap[dateKey] || 0;
      cumulative += dailyCount;

      return {
        xValue: index,
        dateKey,
        xLabel: moment(dateKey).format("DD MMM"),
        dailyCount,
        cumulativeCount: cumulative,
      };
    });
  }, [
    isUniverseView,
    universeBucketDates,
    universeDateCountMap,
  ]);

  // ⭐ 26 Jan 2026 — My contribution within Universe scope
  const myUniverseContributionCount = React.useMemo(() => {
    if (!allReflectionsRaw.length) return 0;

    return allReflectionsRaw.filter(r => {
      if (!r.reflectionDate) return false;
      const m = moment(r.reflectionDate);

      switch (activeTimeBucket) {
        case "today":
          return m.isSame(startOfToday, "day");

        case "week":
          return m.isBetween(startOfWeek, endOfWeek, null, "[]");

        case "month":
          return m.isBetween(startOfMonth, endOfMonth, null, "[]");

        case "quarter":
          return m.isBetween(startOfQuarter, endOfQuarter, null, "[]");

        case "year":
          return m.isBetween(startOfYear, endOfYear, null, "[]");

        case "byYear":
          return m.year() === activeYear;

        case "all":
        default:
          return true;
      }
    }).length;
  }, [
    allReflectionsRaw,
    activeTimeBucket,
    activeYear,
    startOfToday,
    startOfWeek,
    endOfWeek,
    startOfMonth,
    endOfMonth,
    startOfQuarter,
    endOfQuarter,
    startOfYear,
    endOfYear,
  ]);

  // ⭐ 26 Jan 2026 — My share of universe (%)
  const myUniverseSharePct = React.useMemo(() => {
    if (!universeTotalCount) return 0;
    return Math.round((myUniverseContributionCount / universeTotalCount) * 100);
  }, [myUniverseContributionCount, universeTotalCount]);

  // ⭐ 26 Jan 2026 — Universe daily intensity
  const universeDailyAverage = React.useMemo(() => {
    if (!universeBucketDates.length) return 0;
    return Math.round(universeTotalCount / universeBucketDates.length);
  }, [universeTotalCount, universeBucketDates]);

  // ⭐ 26 Jan 2026 — Universe totals per org (for ranking)
  const universeTotalsByOrg = React.useMemo(() => {
  const map = {};

    universeTimeScopedTotals.forEach(row => {
      if (!row?.orgId || typeof row.dailyCount !== "number") return;

      const orgId = row.orgId.toString();
      map[orgId] = (map[orgId] || 0) + row.dailyCount;
    });

    return map;
  }, [universeTimeScopedTotals]);

  // ⭐ 26 Jan 2026 — Universe org totals (sorted)
  const universeOrgTotalsSorted = React.useMemo(() => {
    return Object.entries(universeTotalsByOrg)
      .map(([orgId, total]) => ({ orgId, total }))
      .sort((a, b) => b.total - a.total);
  }, [universeTotalsByOrg]);

  // ⭐ 26 Jan 2026 — My org rank in universe
  const universeRankMeta = React.useMemo(() => {
    if (!userOrgId || !universeOrgTotalsSorted.length) return null;

    const myOrgId = userOrgId.toString();

    const index = universeOrgTotalsSorted.findIndex(
      o => o.orgId === myOrgId
    );

    if (index === -1) {
      return {
        myRank: null,
        totalOrgs: universeOrgTotalsSorted.length,
        myOrgTotal: 0,
      };
    }

    return {
      myRank: index + 1,
      totalOrgs: universeOrgTotalsSorted.length,
      myOrgTotal: universeOrgTotalsSorted[index].total,
    };
  }, [universeOrgTotalsSorted, userOrgId]);

  // ⭐ 26 Jan 2026 — Universe benchmarks
  const universeBenchmarks = React.useMemo(() => {
    if (!universeOrgTotalsSorted.length) return null;

    const totals = universeOrgTotalsSorted.map(o => o.total);
    const max = totals[0];
    const min = totals[totals.length - 1];
    const median =
      totals.length % 2 === 1
        ? totals[Math.floor(totals.length / 2)]
        : Math.round(
            (totals[totals.length / 2 - 1] + totals[totals.length / 2]) / 2
          );

    return { max, min, median };
  }, [universeOrgTotalsSorted]);

  // ⭐ 26 Jan 2026 — Human-friendly Universe time label
  const universeTimeLabel = React.useMemo(() => {
    switch (activeTimeBucket) {
      case "today":
        return "today";
      case "week":
        return "this week";
      case "month":
        return "this month";
      case "quarter":
        return "this quarter";
      case "year":
        return "this year";
      case "byYear":
        return `year ${activeYear}`;
      case "all":
        return "all time periods";
      default:
        return activeTimeBucket;
    }
  }, [activeTimeBucket, activeYear]);

  // ⭐⭐ 29 Jan 2026 - orgUserDailyTotalsRaw
  const orgUserDailyTotalsRaw = React.useMemo(() => {
    if (!reflectionsResponse || Array.isArray(reflectionsResponse)) return [];
    return reflectionsResponse.orgUserDailyTotals || [];
  }, [reflectionsResponse]);

  // ⭐⭐ 30 Jan 2026
  const universeByOrgMap = React.useMemo(() => {
    const map = {};

    const isInActiveTimeBucket = (dateStr) => {
      const m = moment(dateStr);

      switch (activeTimeBucket) {
        case "today":
          return m.isSame(startOfToday, "day");

        case "week":
          return m.isBetween(startOfWeek, endOfWeek, null, "[]");

        case "month":
          return m.isBetween(startOfMonth, endOfMonth, null, "[]");

        case "quarter":
          return m.isBetween(startOfQuarter, endOfQuarter, null, "[]");

        case "year":
          return m.isBetween(startOfYear, endOfYear, null, "[]");

        case "byYear":
          return m.year() === activeYear;

        case "all":
        default:
          return true;
      }
    };

    orgUserDailyTotalsRaw
      .filter(row => row?.date && isInActiveTimeBucket(row.date))
      .forEach(row => {
        const orgId = row.orgId?.toString();
        const userId = row.userId?.toString();

        if (!orgId || !userId) return;

        if (!map[orgId]) {
          map[orgId] = {
            total: 0,
            users: {},
          };
        }

        map[orgId].total += row.dailyCount;
        map[orgId].users[userId] =
          (map[orgId].users[userId] || 0) + row.dailyCount;
      });

    return map;
  }, [
    orgUserDailyTotalsRaw,
    activeTimeBucket,
    activeYear,
    startOfToday,
    startOfWeek,
    endOfWeek,
    startOfMonth,
    endOfMonth,
    startOfQuarter,
    endOfQuarter,
    startOfYear,
    endOfYear,
  ]);

  // console.log('universeByOrgMap', universeByOrgMap)

  // ⭐⭐ 30 Jan 2026   
  const userIdToFirstNameMap = React.useMemo(() => {
    const map = {};

    allUsers.forEach(user => {
      if (!user?._id) return;

      const displayName =
        user.name ||
        user.username ||
        "User";

      map[user._id.toString()] = displayName.split(" ")[0];
    });

    return map;
  }, [allUsers]);

  // ⭐ 31 Jan 2026 
  const universeOrgCumulativeSeries = React.useMemo(() => {
    const map = {};

    orgDailyTotalsRaw
      .filter(row => {
        if (!row?.date) return false;
        const m = moment(row.date);

        switch (activeTimeBucket) {
          case "today":
            return m.isSame(startOfToday, "day");
          case "week":
            return m.isBetween(startOfWeek, endOfWeek, null, "[]");
          case "month":
            return m.isBetween(startOfMonth, endOfMonth, null, "[]");
          case "quarter":
            return m.isBetween(startOfQuarter, endOfQuarter, null, "[]");
          case "year":
            return m.isBetween(startOfYear, endOfYear, null, "[]");
          case "byYear":
            return m.year() === activeYear;
          case "all":
          default:
            return true;
        }
      })
      .forEach(row => {
        const orgId = row.orgId?.toString();
        if (!orgId) return;

        if (!map[orgId]) {
          map[orgId] = {};
        }

        map[orgId][row.date] =
          (map[orgId][row.date] || 0) + row.dailyCount;
      });

    // convert to cumulative series
    const result = {};

    Object.entries(map).forEach(([orgId, dateMap]) => {
      let cumulative = 0;

      const series = Object.keys(dateMap)
        .sort()
        .map((date, idx) => {
          cumulative += dateMap[date];
          return {
            xValue: idx,
            dateKey: date,
            xLabel: moment(date).format("DD MMM"),
            cumulativeCount: cumulative,
          };
        });

      result[orgId] = series;
    });

    return result;
  }, [
    orgDailyTotalsRaw,
    activeTimeBucket,
    activeYear,
    startOfToday,
    startOfWeek,
    endOfWeek,
    startOfMonth,
    endOfMonth,
    startOfQuarter,
    endOfQuarter,
    startOfYear,
    endOfYear,
  ]);

  // ⭐ 31 Jan 2026 - rankBgClass - color the org ranks
  const rankBgClass = (idx) =>
  idx === 0
    ? "bg-lime-600 text-white"
    : idx === 1
    ? "bg-yellow-400 text-gray-900"
    : idx === 2
    ? "bg-orange-200 text-gray-900"
    : idx === 3
    ? "bg-purple-100 text-gray-900"
    : idx === 4
    ? "bg-blue-100 text-gray-900"
    : "bg-gray-100 text-gray-700";


  // ⭐ 31 Jan 2026 - get selected users for an org for charting
  const getSelectedUserForOrg = (orgId, users) =>
    selectedOrgUserMap[orgId] || users?.[0]?.[0];

  const handleUserSelect = (orgId, userId) => {
    setSelectedOrgUserMap(prev => ({
      ...prev,
      [orgId]: userId,
    }));
  };

  // ⭐ 31 Jan 2026 – Org → User cumulative reflection series
  const universeUserCumulativeSeries = React.useMemo(() => {
    const map = {};

    orgUserDailyTotalsRaw
      .filter(row => {
        if (!row?.date) return false;
        const m = moment(row.date);

        switch (activeTimeBucket) {
          case "today":
            return m.isSame(startOfToday, "day");
          case "week":
            return m.isBetween(startOfWeek, endOfWeek, null, "[]");
          case "month":
            return m.isBetween(startOfMonth, endOfMonth, null, "[]");
          case "quarter":
            return m.isBetween(startOfQuarter, endOfQuarter, null, "[]");
          case "year":
            return m.isBetween(startOfYear, endOfYear, null, "[]");
          case "byYear":
            return m.year() === activeYear;
          case "all":
          default:
            return true;
        }
      })
      .forEach(row => {
        const orgId = row.orgId?.toString();
        const userId = row.userId?.toString();
        if (!orgId || !userId) return;

        if (!map[orgId]) map[orgId] = {};
        if (!map[orgId][userId]) map[orgId][userId] = {};

        map[orgId][userId][row.date] =
          (map[orgId][userId][row.date] || 0) + row.dailyCount;
      });

    const result = {};

    Object.entries(map).forEach(([orgId, userMap]) => {
      result[orgId] = {};

      Object.entries(userMap).forEach(([userId, dateMap]) => {
        let cumulative = 0;

        result[orgId][userId] = Object.keys(dateMap)
          .sort()
          .map((date, idx) => {
            cumulative += dateMap[date];
            return {
              xValue: idx,
              dateKey: date,
              xLabel: moment(date).format("DD MMM"),
              cumulativeCount: cumulative,
            };
          });
      });
    });

    return result;
  }, [
    orgUserDailyTotalsRaw,
    activeTimeBucket,
    activeYear,
    startOfToday,
    startOfWeek,
    endOfWeek,
    startOfMonth,
    endOfMonth,
    startOfQuarter,
    endOfQuarter,
    startOfYear,
    endOfYear,
  ]);

  // ⭐ 05 Feb 2026 – Org Name Visibility Toggle
  const toggleOrgNameVisibility = (orgId) => {
    setShowOrgNameMap(prev => ({
      ...prev,
      [orgId]: !prev[orgId],
    }));
  };

  // ⭐ 05 Feb 2026 – User Name Visibility Toggle
  const toggleUserNameVisibility = (userId) => {
    setShowUserNameMap(prev => ({
      ...prev,
      [userId]: !prev[userId],
    }));
  };


  // 🔐 05 Feb 2026 – cryptic org display (GRI, Et, etc.)
  const getCrypticOrgName = (orgName = "") => {
    if (!orgName) return "PN";

    const words = orgName
      .split(" ")
      .map(w => w.trim())
      .filter(Boolean);

    // Case 1: Multi-word org → initials (Growth Rocket Inc → GRI)
    if (words.length > 1) {
      return words
        .map(w => w[0])
        .join("")
        .toUpperCase();
    }

    // Case 2: Single word → first 2 letters (Eternity → Et)
    return orgName.substring(0, 2);
  };

  // 🔐 05 Feb 2026 – cryptic user display (AP, JS, etc.)
  const getCrypticUserName = (userName = "") => {
    if (!userName) return "U";

    const parts = userName
      .split(" ")
      .map(p => p.trim())
      .filter(Boolean);

    // First + Last initials (Atul Pandey → AP)
    if (parts.length >= 2) {
      return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
    }

    // Single name fallback (Atul → A)
    return parts[0][0].toUpperCase();
  };


  // 24 Feb 2026 - Handle Logout
  const handleLogout = async () => {
    try {
      await sendLogout().unwrap();
      navigate('/login')
    } catch (err) {
      console.error('Logout failed:', err);
    }
  };

   
  // -----------------------------------------
  // 16. UI — Start
  // -----------------------------------------
  return (
    <div className="flex flex-col h-screen bg-gray-200 p-4 rounded m-1 overflow-auto max-w-md mx-auto ml-1 mr-1 font-poppins">

      {/* -------------------------------- */}
      {/* Header (mobile sticky) */}
      {/* -------------------------------- */}
      <div className="top-0 z-30 bg-white border-b mx-2 px-2 rounded-xl">

         {/* Logout */}
      <div className="flex justify-end cursor-pointer m-1 p-1" onClick={handleLogout}>
        <div className="flex justify-center items-center rounded-full w-6 h-6 bg-gradient-to-r from-orange-800 to-orange-800 via-orange-600 shadow-xl shadow-gray-600">
          <EtLogoutIcon1SVGComp className="h-4 w-4 text-white" />
        </div>
      </div>

        {/* Trinity Bar (tap logo to go back / close) */}
        <div className="flex justify-center items-center m-1 p-1">
          <div
            className="flex justify-center items-center rounded-full shadow-lg shadow-gray-600 cursor-pointer"
            onClick={() => navigate('/etapp/mobile')}
          >
            <img src={TrinityIcon} alt="" className="h-20 w-20" />
          </div>
        </div>

        {/* Title */}
        <div className="flex justify-center items-center px-3 py-3">
          <div className="flex justify-center items-center">
            <EtWabReflectionIcon1SVGComp className="h-7 w-7 text-orange-600" />
            <h3 className="font-bold text-gray-800 py-2 text-xl mx-1 px-1">
              Reflection Center
            </h3>
          </div>
        </div>

        {/* Subtitle */}
        <div className="px-3 pb-2">
          <p className="text-xs text-gray-600 text-center">
            See how you have been shaping your{" "}
            <span className="font-bold text-orange-800">journey</span>...
          </p>
        </div>

        {/* Count Badge */}
        <div className="flex justify-center items-center my-3 bg-orange-50 py-3 border-t border-b rounded mx-1">
          <span className="text-sm text-gray-700 mx-1 px-1">There are</span>
          <div className="w-8 h-8 rounded-full bg-orange-600 text-white flex justify-center items-center text-lg font-bold">
            {finalReflections?.length || 0}
          </div>
          <span className="text-sm text-gray-700 mx-1 px-1">reflections!</span>
        </div>

        {/* -------------------------------- */}
        {/* Time Chips (scrollable) */}
        {/* -------------------------------- */}
        <div className="px-2 pb-2">
          <div className="flex gap-2 overflow-x-auto no-scrollbar py-2">
            {[
              { label: "Today", value: "today" },
              { label: "Week", value: "week" },
              { label: "Month", value: "month" },
              { label: "Qtr", value: "quarter" },
              { label: "Year", value: "year" },
              { label: "By Year", value: "byYear" },
              { label: "All", value: "all" },
            ].map(({ label, value }) => (
              <button
                key={value}
                onClick={() => setActiveTimeBucket(value)}
                className={`whitespace-nowrap px-3 py-1 rounded-full text-xs font-semibold border shadow-sm
                  ${activeTimeBucket === value
                    ? "bg-orange-600 text-white border-orange-700"
                    : "bg-gray-100 text-gray-700 border-gray-300"
                  }`}
              >
                {label}
              </button>
            ))}
          </div>

          {/* Time bucket description */}
          {timeBucketDescription && (
            <div className="mt-2 mx-1 px-3 py-2 bg-orange-50 border border-orange-200 rounded">
              <p className="text-xs text-gray-700">
                {timeBucketDescription}
              </p>
            </div>
          )}

          {/* By Year selector */}
          {activeTimeBucket === "byYear" && (
            <div className="flex gap-2 overflow-x-auto no-scrollbar mt-2 px-1 pb-2">
              {availableYears.map((year) => (
                <button
                  key={year}
                  onClick={() => setActiveYear(year)}
                  className={`whitespace-nowrap px-3 py-1 rounded-full text-xs font-semibold border shadow-sm
                    ${activeYear === year
                      ? "bg-orange-600 text-white border-orange-700"
                      : "bg-gray-100 text-gray-700 border-gray-300"
                    }`}
                >
                  {year}
                </button>
              ))}
            </div>
          )}

          {/* View Mode Toggle — Self / Collective / Universe */}
          {canViewCollective && (
            <div className="mt-2 mx-1 flex gap-2 overflow-x-auto no-scrollbar py-2">
              {[
                { label: "Self", value: "self" },
                { label: "Collective", value: "collective" },
                { label: "Universe", value: "universe" },
              ].map(({ label, value }) => (
                <button
                  key={value}
                  onClick={() => setViewMode(value)}
                  className={`whitespace-nowrap px-3 py-1 rounded-full text-xs font-semibold border shadow-sm
                    ${viewMode === value
                      ? "bg-orange-600 text-white border-orange-700"
                      : "bg-gray-100 text-gray-700 border-gray-300"
                    }`}
                >
                  {label}
                </button>
              ))}
            </div>
          )}

          {/* Collective User Selector */}
          {viewMode === "collective" && (
            <div className="flex items-center gap-2 overflow-x-auto no-scrollbar mt-2 px-1 pb-2">
              <button
                onClick={() => setActiveCollectiveUserId("all")}
                className={`whitespace-nowrap px-3 py-1 rounded-full text-xs font-semibold border shadow-sm
                  ${activeCollectiveUserId === "all"
                    ? "bg-orange-600 text-white border-orange-700"
                    : "bg-gray-100 text-gray-700 border-gray-300"
                  }`}
              >
                Everyone
              </button>

              {collectiveUsers.map((user) => (
                <button
                  key={user._id}
                  onClick={() => handleCollectiveUserSelect(user._id)}
                  className={`whitespace-nowrap px-3 py-1 rounded-full text-xs font-semibold border shadow-sm
                    ${activeCollectiveUserId === user._id
                      ? "bg-orange-600 text-white border-orange-700"
                      : "bg-gray-100 text-gray-700 border-gray-300"
                    }`}
                >
                  {user.name.split(" ")[0]}
                </button>
              ))}
            </div>
          )}

          {/* View Tabs (segmented) — hide in Universe */}
          {viewMode !== "universe" && (
            <div className="mt-2 mx-1 grid grid-cols-2 bg-gray-100 rounded-lg p-1">
              <button
                onClick={() => setActiveViewTab("log")}
                className={`text-sm font-semibold py-2 rounded-md
                  ${activeViewTab === "log"
                    ? "bg-white text-orange-700 shadow-sm"
                    : "text-gray-500"
                  }`}
              >
                Log
              </button>

              <button
                onClick={() => setActiveViewTab("chart")}
                className={`text-sm font-semibold py-2 rounded-md
                  ${activeViewTab === "chart"
                    ? "bg-white text-orange-700 shadow-sm"
                    : "text-gray-500"
                  }`}
              >
                Chart
              </button>
            </div>
          )}

          {/* Contributions shortcut chip (only when eligible) */}
          {viewMode !== "universe" && viewMode === "collective" && activeCollectiveUserId === "all" && (
            <div className="mt-2 mx-1">
              <button
                onClick={() => setActiveViewTab("contributions")}
                className={`w-full text-sm font-semibold py-2 rounded-md border shadow-sm
                  ${activeViewTab === "contributions"
                    ? "bg-orange-600 text-white border-orange-700"
                    : "bg-white text-orange-700 border-orange-200"
                  }`}
              >
                Contributions
              </button>
            </div>
          )}
        </div>
      </div>

      {/* -------------------------------- */}
      {/* Body */}
      {/* -------------------------------- */}
      <div className="px-2 py-2">

        {/* -------------------------------- */}
        {/* LOG VIEW */}
        {/* -------------------------------- */}
        {viewMode !== "universe" && activeViewTab === "log" && (
          <>
            {/* Search */}
            <div className="mt-3">
              <input
                type="text"
                placeholder="Search reflections..."
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                className="w-full border px-3 py-2 rounded text-sm focus:outline-none focus:ring-2 focus:ring-orange-500"
              />
            </div>

            {/* Add Button */}
            <div className="flex justify-start items-center my-3">
              <p className="font-bold text-xs mr-2">Add a reflection</p>
              <button type="button" onClick={() => setShowCreateModal(true)}>
                <PlusIcon className="h-5 w-5 text-white p-1 rounded bg-lime-600 hover:bg-green-600" />
              </button>
            </div>

            {/* Results */}
            <div className="mt-2">
              {isLoading ? (
                <p className="text-gray-500 text-sm">Loading your reflections...</p>
              ) : finalReflections.length === 0 ? (
                <p className="text-gray-500 text-sm">No reflections found.</p>
              ) : (
                <div className="space-y-3">
                  {finalReflections.map((refItem, idx) => {
                    const allowFullView = canViewFullReflection(refItem, userId);

                    const cardMode =
                      viewMode === "collective" && !allowFullView
                        ? "summary"
                        : "full";

                    return (
                      <EtReflectionCardMobile
                        key={refItem._id}
                        refItem={refItem}
                        index={idx}
                        showDetail={showDetail}
                        toggleShowDetail={toggleShowDetail}
                        handleEdit={onEdit}
                        handleDelete={onDelete}
                        createMarkup={createMarkup}
                        mode={cardMode}
                        showOwner={viewMode === "collective" && activeCollectiveUserId === "all"}
                      />
                    );
                  })}
                </div>
              )}
            </div>
          </>
        )}

        {/* -------------------------------- */}
        {/* CHART VIEW */}
        {/* -------------------------------- */}
        {viewMode !== "universe" && activeViewTab === "chart" && (
          <div className="bg-white border rounded-xl shadow-sm p-3">

            {/* Aggregate vs Compare */}
            {viewMode === "collective" && activeCollectiveUserId === "all" && (
              <div className="flex gap-2 mb-3">
                <button
                  onClick={() => setChartViewMode("aggregate")}
                  className={`text-xs font-semibold px-3 py-1 rounded-full
                    ${chartViewMode === "aggregate"
                      ? "bg-orange-600 text-white"
                      : "bg-gray-200 text-gray-700"
                    }`}
                >
                  Everyone
                </button>

                <button
                  onClick={() => setChartViewMode("compare")}
                  className={`text-xs font-semibold px-3 py-1 rounded-full
                    ${chartViewMode === "compare"
                      ? "bg-orange-600 text-white"
                      : "bg-gray-200 text-gray-700"
                    }`}
                >
                  Compare
                </button>
              </div>
            )}

            {/* Chart Sub Tabs */}
            <div className="flex gap-2 mb-4">
              <button
                onClick={() => setChartTab("streak")}
                className={`text-sm font-semibold px-3 py-1 rounded
                  ${chartTab === "streak" ? "bg-orange-200 text-orange-800" : "text-gray-500"}`}
              >
                Streak
              </button>

              <button
                onClick={() => setChartTab("counts")}
                className={`text-sm font-semibold px-3 py-1 rounded
                  ${chartTab === "counts" ? "bg-orange-200 text-orange-800" : "text-gray-500"}`}
              >
                Daily & Cumulative
              </button>
            </div>

            {/* Existing chart content (unchanged) */}
            {chartTab === "streak" && (
              <>
                <p className="text-sm font-semibold text-gray-700 mb-2">
                  Reflection Streak — Time of Day vs Date
                </p>

                <div className="w-full h-[420px] text-xs">
                  <ResponsiveContainer>
                    <LineChart
                      data={chartData}
                      margin={{ top: 20, right: 20, bottom: 20, left: 20 }}
                    >
                      <CartesianGrid strokeDasharray="3 3" />

                      <XAxis
                        type="number"
                        dataKey="xValue"
                        domain={["dataMin", "dataMax"]}
                        ticks={allDatePoints.map((d) => d.xValue)}
                        tickFormatter={(x) =>
                          allDatePoints.find((d) => d.xValue === x)?.xLabel || ""
                        }
                      />

                      <YAxis
                        type="number"
                        domain={[60, 1440]}
                        ticks={[60, 180, 360, 540, 720, 900, 1080, 1260]}
                        tickFormatter={(m) =>
                          moment().startOf("day").add(m, "minutes").format("h A")
                        }
                      />

                      <Tooltip
                        content={({ active, payload }) => {
                          if (!active || !payload?.length) return null;
                          const p = payload[0]?.payload;
                          const dateStr = moment(p.createdAt).format("ddd, DD MMM YYYY");
                          const timeStr = moment(p.createdAt).format("h:mm A");

                          return (
                            <div className="bg-white p-3 border border-gray-300 rounded shadow-lg">
                              <p className="font-semibold text-gray-700">{dateStr}</p>
                              <p className="text-sm text-gray-600">{timeStr}</p>
                            </div>
                          );
                        }}
                      />

                      <Line
                        type="monotone"
                        dataKey="epochMinutes"
                        stroke="#EA580C"
                        strokeWidth={2}
                        dot={{ r: 3, fill: "#EA580C" }}
                        name="Reflection"
                        connectNulls={true}
                      />
                    </LineChart>
                  </ResponsiveContainer>
                </div>
              </>
            )}

            {chartTab === "counts" && (
              <div className="w-full h-[420px] text-xs">
                <p className="text-sm font-semibold text-gray-700 mb-2">
                  Daily Reflections & Cumulative Trend
                </p>

                <ResponsiveContainer>
                  {chartViewMode === "aggregate" ? (
                    <LineChart
                      data={dailyCountData}
                      margin={{ top: 20, right: 20, bottom: 20, left: 20 }}
                    >
                      <CartesianGrid strokeDasharray="3 3" />

                      <XAxis
                        type="number"
                        dataKey="xValue"
                        ticks={dailyCountData.map((d) => d.xValue)}
                        tickFormatter={(x) =>
                          dailyCountData.find((d) => d.xValue === x)?.xLabel || ""
                        }
                      />

                      <YAxis type="number" allowDecimals={false} />

                      <Tooltip
                        content={({ active, payload }) => {
                          if (!active || !payload?.length) return null;
                          const p = payload[0]?.payload;
                          const dateStr = moment(p.dateKey).format("ddd, DD MMM YYYY");

                          return (
                            <div className="bg-white p-3 border border-gray-300 rounded shadow-lg">
                              <p className="font-semibold text-gray-700">{dateStr}</p>
                              <p className="text-sm text-gray-600">Daily: {p.dailyCount}</p>
                              <p className="text-sm text-gray-600">Cumulative: {p.cumulativeCount}</p>
                            </div>
                          );
                        }}
                      />

                      <Legend wrapperStyle={{ paddingTop: "20px" }} />

                      <Bar
                        dataKey="dailyCount"
                        fill="#65a30d"
                        name="Daily Reflections"
                        barSize={18}
                      />

                      <Line
                        type="monotone"
                        dataKey="cumulativeCount"
                        stroke="#EA580C"
                        strokeWidth={2}
                        dot={{ r: 2, fill: "#EA580C" }}
                        name="Cumulative Reflections"
                      />
                    </LineChart>
                  ) : (
                    <LineChart margin={{ top: 20, right: 20, bottom: 20, left: 20 }}>
                      <CartesianGrid strokeDasharray="3 3" />

                      <XAxis
                        type="number"
                        dataKey="xValue"
                        ticks={allDatePoints.map((d) => d.xValue)}
                        tickFormatter={(x) =>
                          allDatePoints.find((d) => d.xValue === x)?.xLabel || ""
                        }
                      />

                      <YAxis type="number" allowDecimals={false} />

                      <Tooltip
                        content={({ active, payload, label }) => {
                          if (!active || !payload || payload.length === 0) return null;

                          const dateKey = allDatePoints.find(d => d.xValue === label)?.xLabel;

                          return (
                            <div className="bg-white p-3 border border-gray-300 rounded shadow-lg min-w-[180px]">
                              <p className="font-semibold text-gray-700 mb-2">
                                {moment(dateKey, "DD MMM").format("ddd, DD MMM YYYY")}
                              </p>

                              <div className="space-y-1">
                                {payload.map((p, idx) => (
                                  <div key={idx} className="flex items-center justify-between text-sm">
                                    <div className="flex items-center space-x-2">
                                      <span
                                        className="inline-block w-2 h-2 rounded-full"
                                        style={{ backgroundColor: p.stroke }}
                                      />
                                      <span className="text-gray-700 font-medium">{p.name}</span>
                                    </div>
                                    <span className="text-gray-600 font-semibold mx-1">{p.value}</span>
                                  </div>
                                ))}
                              </div>
                            </div>
                          );
                        }}
                      />

                      <Legend />

                      {perUserDailyCumulativeData.map((user, idx) => (
                        <Line
                          key={user.userId}
                          type="monotone"
                          data={user.series}
                          dataKey="cumulativeCount"
                          name={user.userName}
                          strokeWidth={2}
                          dot={{ r: 2 }}
                          stroke={["#EA580C", "#65a30d", "#2563eb", "#7c3aed", "#dc2626"][idx % 5]}
                        />
                      ))}
                    </LineChart>
                  )}
                </ResponsiveContainer>
              </div>
            )}
          </div>
        )}

        {/* -------------------------------- */}
        {/* CONTRIBUTIONS VIEW */}
        {/* -------------------------------- */}
        {viewMode !== "universe" &&
          activeViewTab === "contributions" &&
          activeCollectiveUserId === "all" &&
          reflectionContributionSnapshot?.contributors?.length > 0 && (
            <div className="mt-3">
              <p className="text-lg font-bold m-1 p-1">
                Collective Contribution
              </p>

              <div className="grid grid-cols-2 gap-3 mt-3">
                {reflectionContributionSnapshot.contributors.map((c, idx) => {
                  const isMe = c.userId === userId;

                  return (
                    <div
                      key={`${c.userId}-${idx}`}
                      className="bg-white rounded-lg p-3 shadow-sm border text-center"
                    >
                      <CircularProgressbarWithChildren
                        value={c.percentOfTotal}
                        circleRatio={0.75}
                        styles={{
                          path: {
                            stroke: "#f97316",
                            transform: "rotate(-135deg)",
                            transformOrigin: "center center",
                          },
                          trail: {
                            stroke: "#e5e7eb",
                            transform: "rotate(-135deg)",
                            transformOrigin: "center center",
                          },
                        }}
                      >
                        <div className="flex justify-center">
                          <User
                            username={c.username}
                            defaultUserPic={userProfileIcon2}
                          />
                        </div>

                        <p className="text-[10px] font-semibold mt-3">
                          {c.userName?.split(" ")[0]}
                          {isMe && (
                            <span className="ml-1 text-[9px] text-orange-600 font-bold">
                              (Me)
                            </span>
                          )}
                        </p>

                        <p className="text-xs font-bold text-gray-700">
                          {c.percentOfTotal}%
                        </p>

                        <p className="text-[10px] text-gray-500">
                          {c.count} reflections
                        </p>
                      </CircularProgressbarWithChildren>
                    </div>
                  );
                })}
              </div>
            </div>
          )}

       
      {/* ================================
      🌍 Universe View (Executive Level)
      ================================ */}
      {viewMode === "universe" && (
        <div className="bg-white rounded-xl shadow-sm border p-6 space-y-6">

          {/* 30 Jan 2026 - EtAdmin View Tabs*/}
          {canViewAdminUniverse && (
            <div className="flex space-x-2 mb-4">
              <button
                onClick={() => setUniverseTab("myOrg")}
                className={`px-3 py-1 rounded-full text-sm font-semibold border ${
                  universeTab === "myOrg"
                    ? "bg-orange-600 text-white border-orange-700"
                    : "bg-gray-100 text-gray-700 border-gray-300"
                }`}
              >
                My Org
              </button>

              <button
                onClick={() => setUniverseTab("byOrg")}
                className={`px-3 py-1 rounded-full text-sm font-semibold border ${
                  universeTab === "byOrg"
                    ? "bg-orange-600 text-white border-orange-700"
                    : "bg-gray-100 text-gray-700 border-gray-300"
                }`}
              >
                By Org
              </button>
            </div>
          )}

          {/* 30 Jan 2026 - View Mode and myOrg */}
          {viewMode === "universe" && universeTab === "myOrg" && (
            <>

              {/* Header */}
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-xs uppercase tracking-wide text-gray-400">
                    Trinity Universe · <span className="font-bold text-orange-600">Reflections</span>
                  </p>
                  <h2 className="text-lg font-semibold text-gray-800">
                    Your Universe Performance — {universeTimeLabel}
                  </h2>
                </div>
              </div>

              {/* Primary Metrics */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">

                {/* My Org Contribution */}
                <div className="bg-orange-50 rounded-lg p-4 border border-orange-100">
                  <p className="text-xs text-orange-700 uppercase tracking-wide">
                    My Org Contribution
                  </p>

                  <div className="mt-2 flex items-end gap-2">
                    <p className="text-3xl font-bold text-orange-800">
                      {universeRankMeta?.myOrgTotal || 0}
                    </p>
                    <p className="text-sm text-orange-600">
                      reflections
                    </p>
                  </div>

                  <p className="mt-1 text-xs text-orange-700">
                    {universeTotalCount > 0
                      ? `${Math.round(
                          (universeRankMeta.myOrgTotal / universeTotalCount) * 100
                        )}% of universe`
                      : "—"}
                  </p>
                </div>

                {/* Universe Rank */}
                <div className="bg-purple-50 rounded-lg p-4 border border-purple-100">
                  <p className="text-xs text-purple-700 uppercase tracking-wide">
                    Universe Rank
                  </p>

                  <div className="mt-2 flex items-end gap-2">
                    <p className="text-3xl font-bold text-purple-800">
                      #{universeRankMeta?.myRank ?? "—"}
                    </p>
                    <p className="text-sm text-purple-600">
                      of {universeRankMeta?.totalOrgs || 0}
                    </p>
                  </div>

                  <p className="mt-1 text-xs text-purple-700">
                    Ranked by total reflections
                  </p>
                </div>

                {/* Universe Total */}
                <div className="bg-lime-50 rounded-lg p-4 border border-lime-100">
                  <p className="text-xs text-lime-700 uppercase tracking-wide">
                    Universe Activity
                  </p>

                  <div className="mt-2 flex items-end gap-2">
                    <p className="text-3xl font-bold text-lime-800">
                      {universeTotalCount}
                    </p>
                    <p className="text-sm text-lime-600">
                      reflections
                    </p>
                  </div>

                  <p className="mt-1 text-xs text-lime-700">
                    Across all organizations
                  </p>
                </div>

              </div>

              {/* Narrative Insight */}
              {universeRankMeta && universeTotalCount > 0 && (
                <div className="bg-gray-50 rounded-lg p-4 border">
                  <p className="text-sm text-gray-700 leading-relaxed">
                    Your organization contributed{" "}
                    {/* <span className="font-semibold text-lg text-white bg-orange-600 px-2 rounded-full"> */}
                    <span className="font-bold">
                      {Math.round(
                        (universeRankMeta.myOrgTotal / universeTotalCount) * 100
                      )}%
                    </span>{" "}
                    of all reflections in the Trinity universe during this period,
                    placing you{" "}
                    {/* <span className="font-semibold text-lg text-white bg-orange-600 px-2 rounded-full"> */}
                    <span className="font-bold">
                      #{universeRankMeta.myRank}
                    </span>{" "}
                    out of{" "}
                    {/* <span className="font-semibold text-lg text-white bg-orange-600 px-2 rounded-full"> */}
                    <span className="font-bold">
                      {universeRankMeta.totalOrgs}
                    </span>{" "}
                    organizations.
                  </p>
                </div>
              )}
            
            </>
          )}

          {/* 30 Jan 2026 - View Mode and byOrg  */}
          {viewMode === "universe" && universeTab === "byOrg" && canViewAdminUniverse && (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {Object.entries(universeByOrgMap)
                .sort((a, b) => b[1].total - a[1].total)
                .map(([orgId, data], idx) => (
                  <div
                    key={orgId}
                    className="bg-white rounded-lg p-4 shadow-sm border"
                  >
                    {/* <p className="text-xs text-gray-400 uppercase">
                      Organization #{idx + 1}
                    </p> */}
                    {/* <p
                      className={`inline-block text-xs uppercase font-semibold px-3 py-1 rounded-full ${rankBgClass(idx)}`}
                    >
                      Organization # {idx + 1}
                    </p> */}

                    <div className="flex items-center gap-2">
                      <p className="text-xs text-gray-400 uppercase">
                        Organization
                      </p>

                      <span
                        className={`text-xs font-bold px-3 py-0.5 rounded-full ${rankBgClass(idx)}`}
                      >
                        # <span className="text-lg">{idx + 1}</span>
                      </span>
                    </div>

                    {/* 05 Feb 2026 - Org Name Visibility Toggle */}

                    <div className="flex items-center justify-between mt-1">
                      <p className="text-lg font-bold text-gray-800">
                        {showOrgNameMap[orgId]
                          ? orgIdToNameMap[orgId] || "Unknown Organization"
                          : getCrypticOrgName(orgIdToNameMap[orgId])}
                      </p>

                      <button
                        onClick={() => toggleOrgNameVisibility(orgId)}
                        className="p-1 rounded hover:bg-gray-100"
                        title={showOrgNameMap[orgId] ? "Hide org name" : "Show org name"}
                      >
                        {showOrgNameMap[orgId] ? (
                          <EyeSlashIcon className="h-4 w-4 text-gray-500" />
                        ) : (
                          <EyeIcon className="h-4 w-4 text-gray-400" />
                        )}
                      </button>
                    </div>

                    {/* <p className="text-lg font-bold text-gray-800">
                      { Org ID: {orgId} }
                      {orgIdToNameMap[orgId] || "Unknown Organization"}
                    </p> */}

                    <p className="text-sm text-gray-600 mt-1">
                      Total Reflections:{" "}
                      <span className="font-bold">{data.total}</span>
                    </p>

                    {/* 📈 31 Jan 2026 - Growth Chart */}
                    <div className="mt-4 h-28">
                      <ResponsiveContainer>
                        <LineChart data={universeOrgCumulativeSeries[orgId] || []}>
                          {/* <CartesianGrid strokeDasharray="3 3" /> */}
                          <CartesianGrid
                            strokeDasharray="3 4"
                             stroke="#d1d5db"
                            // strokeDasharray="2 4"
                            // stroke="#e5e7eb"
                          />

                          <XAxis
                            dataKey="xValue"
                            tick={{ fontSize: 9, fill: "#9ca3af" }}
                            interval="preserveStartEnd"
                            tickFormatter={(x) =>
                              universeOrgCumulativeSeries[orgId]?.[x]?.xLabel || ""
                            }
                            // tickFormatter={(x) =>
                            //   universeOrgCumulativeSeries[orgId]?.[x]?.xLabel || ""
                            // }
                            // hide
                          />
                          <YAxis hide />
                          <Tooltip
                            content={({ active, payload }) => {
                              if (!active || !payload?.length) return null;
                              const p = payload[0]?.payload;

                              return (
                                <div className="bg-white p-2 border rounded shadow text-xs">
                                  <p className="font-semibold">
                                    {moment(p.dateKey).format("DD MMM YYYY")}
                                  </p>
                                  <p>Cumulative: {p.cumulativeCount}</p>
                                </div>
                              );
                            }}
                          />
                          <Line
                            type="monotone"
                            dataKey="cumulativeCount"
                            stroke="#EA580C"
                            strokeWidth={2}
                            // dot={false}
                            dot={{
                              r: 2,
                              fill: "#EA580C",
                              stroke: "#fff",
                              // stroke: "#84cc16",
                              strokeWidth: 1,
                            }}
                            activeDot={{ r: 4 }}
                          />
                        </LineChart>
                      </ResponsiveContainer>
                    </div>

                    {/* 👥 Contributors + 📈 User Focus */}
                    <div className="mt-4 grid grid-cols-1 md:grid-cols-3 gap-4">

                      {/* LEFT — Ranked Users */}
                      {/* 05 Feb 2026 - Masked Data */}
                      <div className="space-y-1 md:col-span-1">
                        {Object.entries(data.users)
                          .sort((a, b) => b[1] - a[1])
                          .map(([uid, count], uIdx, arr) => {
                            const fullName = userIdToFirstNameMap[uid] || "User";
                            const showFull = showUserNameMap[uid];

                            return (
                              <button
                                key={uid}
                                onClick={() => handleUserSelect(orgId, uid)}
                                className={`w-full flex justify-between items-center text-xs p-2 border-b rounded
                                  ${
                                    getSelectedUserForOrg(orgId, arr) === uid
                                      ? "bg-orange-100 text-orange-800 font-semibold"
                                      : "hover:bg-gray-50 text-gray-600"
                                  }`}
                              >
                                <span className="flex items-center gap-2">
                                  <span className="text-[10px] text-gray-400">
                                    {uIdx + 1}
                                  </span>

                                  <span>
                                    {/* {showFull ? fullName : getCrypticUserName(fullName)} */}
                                    {showOrgNameMap[orgId]
                                    ? fullName
                                    : getCrypticUserName(fullName)}
                                  </span>
                                </span>

                                <span className="font-bold">{count}</span>
                              </button>
                            );
                          })}
                      </div>



                      {/* <div className="space-y-1 md:col-span-1">
                        {Object.entries(data.users)
                          .sort((a, b) => b[1] - a[1])
                          .map(([uid, count], uIdx, arr) => (
                            <button
                              key={uid}
                              onClick={() => handleUserSelect(orgId, uid)}
                              className={`w-full flex justify-between items-center text-xs p-2 border-b rounded
                                ${
                                  getSelectedUserForOrg(orgId, arr) === uid
                                    ? "bg-orange-100 text-orange-800 font-semibold"
                                    : "hover:bg-gray-50 text-gray-600"
                                }`}
                            >
                              <span className="flex items-center gap-2">
                                <span className="text-[10px] text-gray-400">
                                  {uIdx + 1}
                                </span>
                                <span>{userIdToFirstNameMap[uid] || "User"}</span>
                              </span>

                              <span className="font-bold">{count}</span>
                            </button>
                          ))}
                      </div> */}

                      {/* RIGHT — Selected User Mini Chart */}
                      <div className="h-32 md:col-span-2">
                        <ResponsiveContainer>
                          <LineChart
                            data={
                              universeUserCumulativeSeries?.[orgId]?.[
                                getSelectedUserForOrg(
                                  orgId,
                                  Object.entries(data.users).sort((a, b) => b[1] - a[1])
                                )
                              ] || []
                            }
                          >
                            <CartesianGrid strokeDasharray="3 4" stroke="#d1d5db" />
                            <XAxis hide />
                            <YAxis hide />
                            <Tooltip
                              content={({ active, payload }) => {
                                if (!active || !payload?.length) return null;
                                const p = payload[0].payload;

                                return (
                                  <div className="bg-white p-2 border rounded shadow text-xs">
                                    <p className="font-semibold">
                                      {moment(p.dateKey).format("DD MMM YYYY")}
                                    </p>
                                    <p>Cumulative: {p.cumulativeCount}</p>
                                  </div>
                                );
                              }}
                            />
                            <Line
                              type="monotone"
                              dataKey="cumulativeCount"
                              stroke="#EA580C"
                              strokeWidth={2}
                              dot={{ r: 2 }}
                              activeDot={{ r: 4 }}
                            />
                          </LineChart>
                        </ResponsiveContainer>

                        {/* 05 Feb 2026 */}
                        <p className="mt-1 text-[10px] text-gray-400 text-center">
                          {(() => {
                            const selectedUid = getSelectedUserForOrg(
                              orgId,
                              Object.entries(data.users).sort((a, b) => b[1] - a[1])
                            );

                            const fullName = userIdToFirstNameMap[selectedUid] || "User";

                            return (
                              <>
                                {/* {showUserNameMap[selectedUid]
                                  ? fullName
                                  : getCrypticUserName(fullName)}{" "}
                                · reflection momentum */}
                                {showOrgNameMap[orgId]
                                  ? fullName
                                  : getCrypticUserName(fullName)} · reflection momentum
                              </>
                            );
                          })()}
                        </p>


                        {/* <p className="mt-1 text-[10px] text-gray-400 text-center">
                          {(userIdToFirstNameMap[
                            getSelectedUserForOrg(
                              orgId,
                              Object.entries(data.users).sort((a, b) => b[1] - a[1])
                            )
                          ] || "User")} · reflection momentum
                        </p> */}
                      </div>

                    </div>




                    
                  </div>
                ))}
            </div>
          )}

        </div>
      )}


        {/* Modals */}
        {showUpdateModal && (
          <EtModalUpdateUserReflection
            showModal={showUpdateModal}
            allUsers={allUsers}
            atomicRecord={selectedAtomicRecord}
            onClose={() => {
              setShowUpdateModal(false);
              setSelectedAtomicRecord(null);
            }}
            refetchUserReflectionsAll={refetchUserReflectionsAll}
          />
        )}

        {showCreateModal && (
          <EtModalCreateUserReflection
            showModal={showCreateModal}
            onClose={() => setShowCreateModal(false)}
            refetchUserReflectionsAll={refetchUserReflectionsAll}
            userId={userId}
            userOrgId={userOrgId}
          />
        )}

        {showDeleteModal && (
          <EtModalDeleteUserReflection
            showModal={showDeleteModal}
            atomicRecord={selectedDeleteRecord}
            refetchUserReflectionsAll={refetchUserReflectionsAll}
            onClose={() => {
              setShowDeleteModal(false);
              setSelectedDeleteRecord(null);
            }}
          />
        )}
      </div>
    </div>
  );
};

export default EtTrinityReflectionCenterMobile;